import type Participation from "@travily/types/models/MessagesParticipation";
import { EmptyConversationView } from "./components/EmptyConversationView";
import { ConversationListPanel } from "./conversation-list-panel";

export interface MessagesIndexViewProps {
  participations: Participation[];
  /** Current page URL — the conversation filters live in it. */
  url: string;
}

/**
 * Content region for the messages index. The desktop conversation list lives in the page's
 * `Frame.LeftPane`, which `collapse="drill"` hides below `md` — so this region carries the list on
 * mobile and the pick-a-conversation prompt on desktop. Both branches are mounted and switched in
 * CSS rather than on a viewport hook, so the SSR'd markup is correct at every width.
 */
export function MessagesIndexView({ participations, url }: MessagesIndexViewProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex flex-1 flex-col md:hidden">
        <ConversationListPanel participations={participations} url={url} />
      </div>
      <div className="hidden flex-1 md:flex md:items-center md:justify-center">
        <EmptyConversationView />
      </div>
    </div>
  );
}
